import {Injector, NgModule} from "@angular/core";
import {CommonModule,  Location, LocationStrategy, PathLocationStrategy} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import { FormsModule } from '@angular/forms';
import { AccordionModule } from "ngx-bootstrap/accordion";
// TODO: Angular16Fix TreeModule
// import { TreeModule } from '@circlon/angular-tree-component';
import { FiltersModule_Catalogue} from '@signature-it/ngx-catalogue/components/filters';
import { TreeViewModule_Catalogue } from './tree-view/tree-view.module';
import { SidebarSearchModule_Catalogue} from './search/search.module';
import { SidebarComponent_Catalogue } from "./sidebar.component";
import { SortModule_Catalogue} from '@signature-it/ngx-catalogue/components/sort';
import {CmsModule}  from '@signature-it/ngx-generic/components/cms';
import {createCustomElement} from "@angular/elements";

@NgModule({
    declarations: [
        SidebarComponent_Catalogue
    ],
    imports: [
        CommonModule,
        AccordionModule.forRoot(),
        TranslateModule,
        FormsModule,
        // TreeModule,
        CmsModule,
        SidebarSearchModule_Catalogue,
        FiltersModule_Catalogue,
        TreeViewModule_Catalogue,
        SortModule_Catalogue,
        RouterModule
    ],
    providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
    exports: [SidebarComponent_Catalogue]
})
export class SidebarModule_Catalogue {
    constructor(private injector: Injector) {
        const CatalogueSidebarGenericComp = createCustomElement(SidebarComponent_Catalogue, {injector});
        !customElements.get('ngx-catalogue-sidebar') && customElements.define('ngx-catalogue-sidebar', CatalogueSidebarGenericComp);
    }
}
